import { render, staticRenderFns } from "./CardCatalogDetail.vue?vue&type=template&id=3aeb7e21&"
import script from "./CardCatalogDetail.vue?vue&type=script&lang=js&"
export * from "./CardCatalogDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports